// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
//引入可移动的dialog
import './utils/directives'
// 公共样式
import './assets/css/xunyou.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.setGlobleTitle = (title)=>{ document.title = title }
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
//线上地址: 8.140.122.249
//服务器端 支付(基本上不修改)
Vue.prototype.$payUrl = 'https://www.gstianze.com/center'
// //服务器端 基础地址
Vue.prototype.$baseUrl = 'https://www.gstianze.com/center'

// Vue.prototype.$payUrl = 'http://39.98.76.44:8086/chenan'
//服务器端 基础地址
// Vue.prototype.$baseUrl = 'http://39.98.76.44:8086/chenan'
//本地测试 支付Vue.prototype.$payUrl = 'http://192.168.0.117:8089/center'
//本地测试 基础地址Vue.prototype.$baseUrl = 'http://192.168.0.117:8089/center'
//本地测试 支付Vue.prototype.$payUrl = 'http://222.89.85.171:8089/center'
//本地测试 基础地址
// Vue.prototype.$baseUrl = 'http://127.0.0.1:8080/center'
// Vue.prototype.$payUrl = 'http://127.0.0.1:8080/center'


// 使用element UI
Vue.use(ElementUI);
//地图定位组件

import VueAMap from 'vue-amap';
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({

    key: 'ebd1337d8177f94f8515451a9023f23d',
    plugin: [
        'AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.ToolBar',
        'AMap.MapType',
        'AMap.PolyEditor',
        'AMap.CircleEditor',
        'AMap.Geolocation'
    ],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});
// 过滤器
import * as custom from './utils/util'

// 引入layui
// import layui from './assets/layui/layui'
// // import './assets/layui/css/modules/layer/default'
// Vue.prototype.$layui = layui

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 路由拦截器
router.beforeEach((to, from, next) => {
//    console.log(to.fullPath,"55");
//    if(to.fullPath=='/menchantpayFor'){
//        console.log("ture");
//        next({
//         path: '/menchantpayFor',
//         query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
//     })
//    }
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("userdata"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        }
        else {
            next();
        //     if (Boolean(localStorage.getItem("userdata"))) { // 判断是否登录
        //         if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
        //             next();
        //         } else {
        //             /**
        //              * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
        //              */
        //             next({
        //                 path: '/dashboard/main'
        //             })
        //         }
        //     } else {
        //         next();
        //     }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

// 禁止在控制台打印
// console.log = function(){}
//  alert = function(){}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js